import { render, staticRenderFns } from "./superdocument-reply.vue?vue&type=template&id=0811cce0&scoped=true&"
import script from "./superdocument-reply.vue?vue&type=script&lang=js&"
export * from "./superdocument-reply.vue?vue&type=script&lang=js&"
import style0 from "./superdocument-reply.vue?vue&type=style&index=0&id=0811cce0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0811cce0",
  null
  
)

export default component.exports